import React, { useState } from 'react';
import Tasks from '../Tasks/Tasks';
import EisenhowerMatrix from '../Visualizations/EisenhowerMatrix';


import { WorkshopStepProps } from './WorkshopStep';
import WorkshopComponent from './WorkshopComponent';


const TaskValueAnalysisWorkshop: React.FC = () => {
  const [hasTasks, setHasTasks] = useState(false);

  const steps: WorkshopStepProps[] = [
    {
      title: 'Rate Your Tasks',
      number: 1,
      children: <Tasks view="workshop" onTasksChange={(list) => setHasTasks((list?.length || 0) > 0)} />,
      canProceed: hasTasks,
    },
    {
      title: 'Analyze & Prioritize',
      number: 2,
      children: <EisenhowerMatrix />,
      canProceed: false,  
    },
  ]

  return (
    <WorkshopComponent title="Task Value Analysis" steps={steps} />
  );
};

export default TaskValueAnalysisWorkshop;